<template lang="pug">
  v-dialog(width="320" v-model="showModal")
    template(v-slot:activator="{ on }")
      v-icon.change-color(v-on="on" data-test="change-color-btn" :disabled="disabled") mdi-format-color-fill
    v-card(data-test="change-color-modal")
      v-card-title
        v-icon.back-icon(v-if="editableColor" @click="cancel") mdi-arrow-left
        p.change-color-title Edit color
        v-icon.close-icon(@click="showModal = false") mdi-close
      v-card-text
        div.add-color(v-if="editableColor" data-test="add-edit-color")
          v-text-field(
          type="number"
          placeholder="Order"
          v-model="editableColor.order"
            :error="formErrors.hasError('order')"
              :error-messages="formErrors.fields.order"
          data-test="order-field"
          )
          v-color-picker(mode="hexa" hide-mode-switch v-model="editableColor.hex_color_code")
          div.buttons
            v-btn.save-button(@click="save" color="primary" data-test="color-save-btn") Save
            v-btn.cancel-button(@click="cancel" data-test="color-cancel-btn") Cancel
        div.color-list
          div.color-list__item(v-for="item in colors" :key="item.ID" data-test="color-item")
            p {{ item.order }}
            div.color-value(:style="{'background-color': item.hex_color_code}" @click="onChooseColor(item)" data-test="color-choose-btn")
            v-icon(@click="onEdit(item)" x-small data-test="color-edit-btn") mdi-pencil
            v-icon.margin-l-8(@click="deleteColor(item.id)" x-small data-test="color-delete-btn") mdi-delete
        v-btn.add-button(v-if="!editableColor" color="primary" @click="onAdd" data-test="add-new-color-btn") Add New
        v-btn.clear-button(v-if="!editableColor" @click="clearColor") Clear Color
</template>

<script>
  import { CandidateColor } from '../core/models/candidateColorModel'
  import ErrorMixin from "@/mixins/errors.mixin"
  import FormErrors from "@/util/form-errors"
  import ReservationService from '../core/candidates-service'
  import { mapState, mapActions } from 'vuex'

  export default {
    mixins: [ ErrorMixin ],
    inject: ['svc'],
    props: {
      activeItems: {
        type: Array,
        required: true,
      },
      disabled: {
        type: Boolean,
        default: false,
      }
    },
    data: () => ({
      colorBeforeEdit: null,
      formErrors: new FormErrors(),
      showModal: false,
      editableColor: null,
    }),
    computed: {
      ...mapState('crmCandidateColors', {
        colors: state => state.colors
      }),
      isEdit() {
        return this.editableColor && this.editableColor.id
      }
    },
    watch: {
      showModal(value) {
        if (!value) this.cancel()
      }
    },
    methods: {
      validateOrderRequiredField() {
        if (!this.editableColor.order || !this.editableColor.order.toString().length) {
          this.formErrors.invalidField('order', 'Order is required field')
          return
        } else {
          this.formErrors.validField('order')
        }
      },
      validateOrderDuplicated() {
        const ordersList = this.isEdit ?
          this.colors.map(color => +color.order).filter(id => id !== +this.colorBeforeEdit.order) :
          this.colors.map(color => +color.order)

        if (ordersList.includes(+this.editableColor.order)) {
          this.formErrors.invalidField('order', 'Duplicated order')
        } else {
          this.formErrors.validField('order')
        }
      },
      async onChooseColor(color) {
        const candidatesIds = this.activeItems.map(item => item.ID)
        await this.svc().saveColor(candidatesIds, color.id)
        this.showModal = false;
      },
      async clearColor() {
        const candidatesIds = this.activeItems.map(item => item.ID)
        await this.svc().saveColor(candidatesIds, null)
        this.showModal = false;
      },
      onAdd() {
        this.editableColor = new CandidateColor()
      },
      onEdit(item) {
        this.editableColor = new CandidateColor(item)
        this.colorBeforeEdit = new CandidateColor(item)
      },
      async save() {
        console.log(this.editableColor)
        this.validateOrderRequiredField();
        this.validateOrderDuplicated();

        if (this.formErrors.isValid()) {
          if (this.isEdit) {
            try {
              await this.updateColor(this.editableColor)
            } catch (err) {
              this.processError(err);
            }
          } else {
            try {
              await this.createColor(this.editableColor)
            } catch (err) {
              this.processError(err);
            }
          }
          this.cancel()
        }
      },
      cancel() {
        this.editableColor = null;
      },
      ...mapActions({
        createColor: 'crmCandidateColors/createColor',
        updateColor: 'crmCandidateColors/updateColor',
        deleteColor: 'crmCandidateColors/deleteColor',
      })
    }
  }
</script>


<style lang="scss" scoped>

  .change-color{
    cursor: pointer;

    &-title{
      width: 100%;
      text-align: center;
    }
  }

  .back-icon{
    position: absolute;
    top: 18px;
    left: 16px;
  }

  .close-icon{
    cursor: pointer;
    position: absolute;
    right: 16px;
    top: 18px;
  }

  .add-color{
    margin-bottom: 16px;
  }

  .color-list{

    &__item{
      display: flex;
      align-items: center;
      margin-top: 8px;

      p{
        margin: 0;
      }

      .color-value{
        height: 20px;
        width: 200px;
        border-radius: 8px;
        margin: 0 16px;
        cursor: pointer;
      }
    }
  }

  .buttons{
    text-align: right;
  }

  .add-button{
    text-align: center;
    margin: 8px 0;
  }

  .clear-button{
    margin: 8px 4px;
  }

  .save-button, .cancel-button{
    text-align: center;
    margin-left: 4px;
    margin-top: 8px;
  }

  .margin-l-8{
    margin-left: 8px;
  }

</style>